// import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'

import { find, cloneDeep, forEach, differenceBy } from 'lodash'

const buildResidualByParent = (parentCategory) => {
  let residualDishes = cloneDeep(parentCategory.acf.dishes)

  forEach(parentCategory.children, subcategory => {
    residualDishes = differenceBy(residualDishes, subcategory.acf.dishes, x => x.ID)
  })

  if (residualDishes.length === 0) {
    return null
  }

  return {
    acf: {
      dishes: residualDishes,
      icon: false
    },
    children: [],
    id: -1,
    parent: parentCategory,
    slug: 'other',
    title: {
      rendered: 'Без категории'
    }
  }
}

export default {
  categories: state => state.categories,
  dishes: state => state.dishes,
  currentCategory: (state, getters, rootState, rootGetters) => {
    if (state.categories.length === 0) {
      return null
    }
    let category = rootState.route.params.category
    if (!category) {
      return null
    }
    let subcategory = rootState.route.params.subcategory
    if (!subcategory) {
      return state.categories[category]
    }

    if (subcategory === 'other') {
      return buildResidualByParent(state.categories[category])
    }

    let res = cloneDeep(state.categories[category].children[subcategory])
    res.parent = state.categories[category]
    return res
  },
  currentFirstLevelCategory: (state, getters) => {
    if (!getters.currentCategory) {
      return getters.currentCategory
    }

    return getters.currentCategory.parent || getters.currentCategory
  },
  dishById: (state, getters, rootState, rootGetters) => id => find(getters.dishes, (dish) => {
    return dish.ID === id
  }),
  menuLoaded: state => Object.keys(state.categories).length > 0,
  residualSubcategory: (state, getters) => {
    if (!getters.currentCategory.parent.id) {
      return null
    }

    return buildResidualByParent(getters.currentCategory.parent)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/getters.js